import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: "", pathMatch: "full", loadComponent: () => import('./platinum-page/platinum-page.component').then(m => m.PlatinumPageComponent) },
    { path: "how-it-works", pathMatch: "full", loadComponent: () => import('./how-it-works-page/how-it-works-page.component').then(m => m.HowItWorksPageComponent) },
    { path: "pricing", pathMatch: "full", loadComponent: () => import('./pricing-page/pricing-page.component').then(m => m.PricingPageComponent) },
    { path: "faq", pathMatch: "full", loadComponent: () => import('./faq-page/faq-page.component').then(m => m.FaqPageComponent) },
    { path: "proof", pathMatch: "full", loadComponent: () => import('./past-results-page/past-results-page.component').then(m => m.PastResultsPageComponent) },
    { path: "contact", pathMatch: "full", loadComponent: () => import('./contact-us-page/contact-us-page.component').then(m => m.ContactUsPageComponent) },
    { path: "success", pathMatch: "full", loadComponent: () => import('./success-page/success-page.component').then(m => m.SuccessPageComponent) },
    {
        path: '**',
        loadComponent: () => import('./not-found-page/not-found-page.component').then(m => m.NotFoundPageComponent)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        initialNavigation: 'enabledBlocking',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
